import React, { useState } from 'react';
import { Alert} from 'reactstrap';
import { FaChrome, FaSafari, FaInternetExplorer, FaWhatsapp } from 'react-icons/fa';
import { MdMailOutline } from 'react-icons/md';
import { FiPhoneCall } from 'react-icons/fi';
import { AiOutlineExclamationCircle } from 'react-icons/ai';
import { FiCheckCircle } from 'react-icons/fi';



import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Container, Col, Form, Row, FormGroup, Label, Input, } from 'reactstrap';

const ModalsAlert = (props) => {
   
  
    const {
        buttonLabel,
        className, informativo
    } = props;


    const [modal, setModal] = useState(false);

    const toggle = () => setModal(!modal);


    const handleChangeTabs = (e) => {
        console.log(e.target.value)
        console.log(e.target)
        props.handleChangeTabs(e.target.value, e.target.name, props)

    }


    const ValidarCodigoSMS = () => {
   
        props.ValidarCodigoSMS(props)

    }

    const ReenviarCodigo = () => {

        props.ReenviarCodigo()

    }
    const cambiarTelefono = () => {

        props.cambiarTelefono()

    }

    
    


    const CerrarModalFinal = (e) => {
        console.log(props.state.mensajeModal)
        toggle()
        props.CerrarModalFinal()
    

    }

    const CerrarModal = (e) => {
         console.log(props.state.mensajeModal)  
        props.CerrarModal()
            toggle()
     
    }

    if (props.state.mensajeModal =="success") {


        return (
            <div>
                <Modal isOpen={props.state.modal} className={className}>
                    <ModalHeader >Información</ModalHeader>
                    <ModalBody>
                        ¿Está seguro que desea enviar la solicitud?. Una vez enviada, no podrá editar la solicitud.
                        
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={() => props.CerrarModal()}>Regresar</Button>
                        <Button color="success" onClick={() => props.sendDataServer()}>Aceptar</Button>
                    </ModalFooter>
                </Modal>
            </div>
        );
           
    }
    else if (props.state.mensajeModal == "ModalFirma") {


        return (
            <div>
                <Modal isOpen={props.state.modal} className={className}>
                    <ModalHeader >Ejemplo de foto</ModalHeader>
                    <ModalBody>
                        
                        <img className='fotoSelfieEjemplo' src='/images/fotoEjemplo.jpeg' />
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={() => props.CerrarModal()}>Regresar</Button>
                     
                    </ModalFooter>
                </Modal>
            </div>
        );

    }

    else if (props.state.mensajeModal == "Ubicacion") {

        return (
            <div>
                <Modal isOpen={props.state.modal} className={className}>
                    <ModalHeader >Cómo compartir tu ubicación</ModalHeader>
                    <ModalBody>

                        <Col sm={12}>

                            ¿Tiene problemas para compartir su ubicación? 
                             
                            </Col>
                        <Col sm={12} className="textPostalCode">

                            Verifique la documentación disponible segun su navegador.
                            </Col>
                        <br />
                   
                    <div class="row ">
                            <Col sm={4}>
                                <a   target="_blank" href="https://support.google.com/chrome/answer/142065?co=GENIE.Platform%3DDesktop&hl=es-419"><FaChrome /> Chrome</a>

                            </Col>
                            <Col sm={5}>
                                <a target="_blank" href="https://support.microsoft.com/es-es/help/4536154/microsoft-edge-location-and-privacy"><FaInternetExplorer /> Internet Explorer EDGE</a>

                            </Col>
                            <Col sm={3}>
                                <a   target="_blank" href="https://support.apple.com/es-es/HT204690"><FaSafari /> Safari</a>

                            </Col>
                            
                           
                    </div>
                    </ModalBody>
                    <ModalFooter>
                       
                        <Button color="success" onClick={() => props.CerrarModal()}>Aceptar</Button>
                    </ModalFooter>
                </Modal>
            </div>
        );
    }
    
    else if (props.state.mensajeModal == "Direccion") {
    return (
        <div>
            <Modal isOpen={props.state.modal} className={className}>
                <ModalHeader >Información</ModalHeader>
                <ModalBody>
                    {props.state.UbicarPesona}

                </ModalBody>
                <ModalFooter>
                    <Button color="primary" onClick={() => props.CerrarModal()}>Aceptar</Button>
                </ModalFooter>
            </Modal>
        </div>
    );
    }

    else if (props.state.mensajeModal == "CodigoPostal"){
        return (
            <div>
                <Modal isOpen={props.state.modal} className={className}>
                    <ModalHeader >Información</ModalHeader>
                    <ModalBody>
                        <Row className="rowGris">
                            <Col sm={12}>

                                El Código postal no fue encontrado.
                            </Col>
                            <br />
                            <br />
                            <Col sm={12} className="textPostalCode">

                                ¿No puedes encontrar tu código postal? Comunícate con nosotros
                            
                            </Col>

                            <Col sm={4}>
                             
                                <a class="VinculoPostalCode" href="https://wa.me/5215576569519" target="_blank"  ><FaWhatsapp /> +52 (155) 7656 9519</a>
                            </Col>
                           <Col sm={5}>
                                <a class="VinculoPostalCode" href="mailto:name@email.com" target="_blank" ><MdMailOutline /> cliente@maxcapitalmex.com</a>
                            </Col>
                            <Col sm={3}>
                                <div class="VinculoPostalCode" >  <FiPhoneCall /> 55 7656 9519</div>
                            </Col>
                            </Row>
                   

                    </ModalBody>
                    <ModalFooter>
                        <Button color="primary" onClick={() => props.CerrarModal()}>Aceptar</Button>
                    </ModalFooter>
                </Modal>
            </div>
        );
    }

    else if (props.state.mensajeModal == "ValidarSMS") {
        return (
            <div>
                <Modal isOpen={props.state.modal} className={className}>
                    <ModalHeader hidden={props.state.hideEncurso}> <AiOutlineExclamationCircle /> Validación de código SMS</ModalHeader>
                    <ModalHeader hidden={props.state.hideAprobado}>Solicitud enviada con éxito</ModalHeader>
                   
                    <ModalBody>
                        <Row className="rowGris" hidden={props.state.hideEncurso}>
                            <Col sm={12} hidden={props.state.hideTextSMS}>
                               
                                Para enviar la solicitud*, debe ingresar el código que le sera enviado a su celular <b>{props.state.Telf_Particular}</b>. Si desea modificar su número haga <a className="EnlaceURL" onClick={cambiarTelefono}>click aqui</a>
                                </Col>
                          

                            <Col sm={6} hidden={props.state.hidebtnEditartelf} >
                                <Label for="NuevoTelefono" sm={12}>Nuevo Celular</Label>
                                <Input bsSize="sm" type="text" name="Telf_Particular" id="Telf_Particular" className="Telf_Particular" value={props.state.Telf_Particular} onChange={handleChangeTabs} />
                            </Col>
                       
                            <Col sm={6} hidden={props.state.hideinputSMS} >
                                <Label for="NuevoTelefono" sm={12}>código</Label>
                                <Input bsSize="sm" type="text" name="ValidadorSMS" id="ValidadorSMS" className="ValidadorSMS" onChange={handleChangeTabs} />
                            </Col>
                            <Col sm={6} hidden={props.state.hideBTNinputSMS}  >
                                <div className="col-sm-12">    &nbsp;</div>
                                <Button className="btn" onClick={ReenviarCodigo}>{props.state.MensajeValidador}</Button>
                            </Col>
                            <Col sm={12} hidden={props.state.validateTableAlert}>
                                <Alert color="danger">
                                    El código ingresado no es correcto.
                             </Alert>
                            </Col>
                            <Col sm={12} className="textModalSub" hidden={props.state.hideinputSMS}>
                                ¿No recibiste el código? <a className="VinculosubtexModal" onClick={ReenviarCodigo}>Haga click aqui para reenviar el SMS</a>
                            </Col>
                            
                            <Col sm={12} hidden={props.state.hidetextSMS}>
                                Haz alcanzado el límite de solicitudes permitidas. Por favor, ingrese mañana para intentarlo nuevamente
                            </Col>
                        </Row>
                        <Row hidden={props.state.hideAprobado}>

                            <Col sm={12} className="iconoAprobado" >
                            <FiCheckCircle/>
                            </Col>
                        </Row>



                        <br />

                    </ModalBody>
                 
                    <ModalFooter>
           
                        <Col sm={12} className="textModalSubFooter" hidden={props.state.hideEncurso}>
                           *Una vez enviada la solicitud, no podrá editar la solicitud.
                                   </Col>
                        <Button color="success" hidden={props.state.hideAprobado} onClick={() => props.CerrarModalFinal()}>Cerrar</Button>
                        <Button color="primary" hidden={props.state.hideEncurso} onClick={() => props.CerrarModal()}>Cerrar</Button>
                        
                        <Button color="success" hidden={props.state.hideEncurso} hidden={props.state.hidevalidateBTN} onClick={() => props.ValidarCodigoSMS()}>Validar</Button>

             
                    </ModalFooter>
                </Modal>
            </div>
        );
    }


    else {
        return (
            <div>
                <Modal isOpen={props.state.modal} className={className}>
                    <ModalHeader >Información</ModalHeader>
                    <ModalBody>
                        {props.state.mensajeModal}

                    </ModalBody>
                    <ModalFooter>
                        <Button color="primary" onClick={() => props.CerrarModal()}>Aceptar</Button>
                    </ModalFooter>
                </Modal>
            </div>
        );
    }
        
       
    
}

export default ModalsAlert;